import { getLicenses } from '@/service/company'

const initialState = () => {
  return {
    licenses: {
      availableLicenses: 0,
      remainingLicenses: 0,
      activatedUsersCount: 0,
    },
  }
}

let state = initialState()

const getters = {
  licenses: state => state.licenses,
}

const mutations = {
  SET_LICENSES(state, licenses) {
    state.licenses = licenses
  },
  // eslint-disable-next-line no-unused-vars
  async RESETSTATE(state) {
    state = await initialState()
  },
}

const actions = {
  async loadLicenses({ commit }) {
    commit('SET_LICENSES', (await getLicenses()).data)
  },
  async resetState({ commit }) {
    commit('RESETSTATE')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
